import React, { useEffect } from 'react';
import { AppButton, Box, CalendarIcon, Heading } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import PERMISSIONS from '@/common/permissions';
import { Topbar } from '@/modules/core/components';
import theme from '@/styles/theme';

import { useHasAccess, useHistory } from '../core';
import Link from '../core/components/Link';

import NewReportsList from './NewReportsList';

const NewReports: React.FC = () => {
  const { removeAllQueryParamsExceptOwn } = useHistory();
  const isHasPermission = useHasAccess([
    {
      permission: PERMISSIONS.REPORTS,
    },
  ]);
  useEffect(() => {
    removeAllQueryParamsExceptOwn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isHasPermission) {
    return null;
  }
  return (
    <div>
      <Box data-testid="reports-wrapper" width="100%">
        <Topbar />
        <Box pad={{ top: '0', bottom: '40px' }}>
          <Box align="center">
            <Box width={theme.defaultContentWidth}>
              <div>
                <Box direction="row" margin={{ top: 'spacing24' }} align="center" justify="between">
                  <Box direction="row" align="center">
                    <Heading data-testid="Reports_header_title" level={1} size="regular" color="textTitle">
                      Reports
                    </Heading>
                  </Box>

                  <Link to={ROUTES.SCHEDULED_REPORTS}>
                    <AppButton buttonType="secondary" rightIcon={<CalendarIcon />}>
                      Schedules
                    </AppButton>
                  </Link>
                </Box>
                <NewReportsList />
              </div>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default NewReports;
